import { MissingSetupScreen } from '@vitvio/shared-components';
import { useUserContext } from '@vitvio/user-context';
import { SurgeryTimeline } from './SurgeryTimeline';
import { Alert, Spinner, useTheme } from '@vitvio/design-system';
import { useTranslation } from '@vitvio/locales';
import { useHospital } from './hooks/useHospital';

export function MissionControl() {
  const {
    activeHospital: { id: hospitalId = null },
  } = useUserContext();
  const { getRadius, getSpacing } = useTheme();
  const { t } = useTranslation();
  const hospitalData = useHospital(hospitalId);

  if (!hospitalId) {
    return <MissingSetupScreen />;
  }

  if (!hospitalData) {
    return (
      <Alert
        status="info"
        borderRadius={getRadius('md')}
        maxW={'80%'}
        maxH={'10%'}
        position={'relative'}
        margin={'auto'}
      >
        <Spinner
          mr={getSpacing('4')}
          label={t('missionControl.loading.spinnerLabel')}
          size={'sm'}
          colorScheme={'blue'}
        />
        {t('missionControl.loading.orStates')}
      </Alert>
    );
  }

  return <SurgeryTimeline hospitalData={hospitalData} />;
}

export default MissionControl;
